import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OpportunitySnapshotsService } from '../services/opportunity-snapshots.service';

@Component({
  selector: 'app-final-page',
  standalone: false,
  templateUrl: './final-page.component.html',
  styleUrl: '../../assets/css/HighLimits.css'
})
export class FinalPageComponent {
  constructor(private _router: Router,
              private _oss: OpportunitySnapshotsService) { }

  email: string = '';
  opportunityName: string = '';
  ngOnInit(): void {
    this.email = this._oss.currentApplicant.Email;
    this.opportunityName = localStorage.getItem('opportunityName') ?? '';
  }

  

  gotoLanding(){
    localStorage.clear();
    this._router.navigate(['/']);
  }  
}

